"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardContent = void 0;
var vue_1 = require("vue");
var CardRequirementsComponent_1 = require("./CardRequirementsComponent");
var CardVictoryPoints_1 = require("./CardVictoryPoints");
var CardDescription_1 = require("./CardDescription");
var CardRenderData_1 = require("./CardRenderData");
exports.CardContent = vue_1.default.component('CardContent', {
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        requirements: {
            type: Object,
        },
        isCorporation: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        CardRequirementsComponent: CardRequirementsComponent_1.CardRequirementsComponent,
        CardVictoryPoints: CardVictoryPoints_1.CardVictoryPoints,
        CardDescription: CardDescription_1.CardDescription,
        CardRenderData: CardRenderData_1.CardRenderData,
    },
    methods: {
        getClasses: function () {
            var classes = ['card-content'];
            if (this.isCorporation) {
                classes.push('card-content-corporation');
            }
            return classes.join(' ');
        },
    },
    template: "\n        <div :class=\"getClasses()\">\n            <CardRequirementsComponent v-if=\"requirements !== undefined\" :requirements=\"requirements\"/>\n            <CardRenderData v-if=\"metadata.renderData !== undefined\" :renderData=\"metadata.renderData\" />\n            <CardDescription v-if=\"metadata.description !== undefined\" :item=\"metadata.description\" />\n            <CardVictoryPoints v-if=\"metadata.victoryPoints !== undefined\" :victoryPoints=\"metadata.victoryPoints\" />\n        </div>\n    ",
});
//# sourceMappingURL=CardContent.js.map